// extracted by css-extract-rspack-plugin
export default {"uploadWallpaper":"src-modules-desktop-components-WallpapersSelector-components-UploadWallpaper-UploadWallpaper-module__uploadWallpaper-zZ_bRn","uploadWallpaperTitle":"src-modules-desktop-components-WallpapersSelector-components-UploadWallpaper-UploadWallpaper-module__uploadWallpaperTitle-xW2lDs","overlay":"src-modules-desktop-components-WallpapersSelector-components-UploadWallpaper-UploadWallpaper-module__overlay-_IAt1j","hiddenInput":"src-modules-desktop-components-WallpapersSelector-components-UploadWallpaper-UploadWallpaper-module__hiddenInput-E_YHvw"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"uploadWallpaper\":\"src-modules-desktop-components-WallpapersSelector-components-UploadWallpaper-UploadWallpaper-module__uploadWallpaper-zZ_bRn\",\"uploadWallpaperTitle\":\"src-modules-desktop-components-WallpapersSelector-components-UploadWallpaper-UploadWallpaper-module__uploadWallpaperTitle-xW2lDs\",\"overlay\":\"src-modules-desktop-components-WallpapersSelector-components-UploadWallpaper-UploadWallpaper-module__overlay-_IAt1j\",\"hiddenInput\":\"src-modules-desktop-components-WallpapersSelector-components-UploadWallpaper-UploadWallpaper-module__hiddenInput-E_YHvw\"}";
        // 1793873552766
        var cssReload = require("../../../../../../../node_modules/.pnpm/@rspack+core@1.5.8_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  